"use client"

import { useAppStore } from "@/store"
import { AnimatePresence, motion } from "framer-motion"
import { useShallow } from "zustand/shallow"
import "../../index.css"

export function CommandMenu() {
	const { isOpen, navigation } = useAppStore(
		useShallow((state) => ({
			isOpen: state.commandOpen,
			navigation: state.navigation,
		})),
	)

	return (
		<AnimatePresence>
			{isOpen && navigation.currentView && (
				<motion.div
					className="absolute inset-0 flex flex-col commandmenu-bg"
					data-no-drag
					initial={{ opacity: 0, scale: 0.95 }}
					style={{ transformOrigin: "bottom center" }}
					onClick={(e) => e.stopPropagation()}
					animate={{
						opacity: 1,
						scale: 1,
						transition: {
							duration: 0.4,
							delay: 0.2,
							ease: [0.16, 1, 0.3, 1],
						},
					}}
					exit={{
						opacity: 0,
						scale: 0.95,
						transition: {
							duration: 0.2,
							ease: [0.16, 1, 0.3, 1],
						},
					}}
				>
					{navigation.currentView}
					{/* Bottom Action Bar */}
					{/* <div className="p-4 pt-2 border-t border-[#e5e5e5] bg-white/60">
						<div className="flex items-center justify-between">
							<div className="flex items-center gap-2 text-[#666] text-xs">
								<span>Press Enter to select</span>
								{navigation.breadcrumb.length > 0 && (
									<>
										<span>•</span>
										<span>Esc to go back</span>
									</>
								)}
							</div>
							<div className="flex items-center gap-2">
								<div className="flex items-center gap-1">
									<kbd className="px-1 py-0.5 rounded text-[10px] kbd">⌘</kbd>
									<kbd className="px-1 py-0.5 rounded text-[10px] kbd">K</kbd>
									<span className="text-[#666] text-xs">to open</span>
								</div>
							</div>
						</div>
					</div> */}
				</motion.div>
			)}
		</AnimatePresence>
	)
}
